import {
  CODIGO_OCURRENCIA_OMISION_PREGUNTA,
  CODIGO_OCURRENCIA_UNICA,
  ESTADOS_RESPUESTA,
  obtenerPrimero,
} from "./configuracionInicial.constants";

const codigoElementoDe = (respuesta) => obtenerPrimero(
  respuesta,
  ["CodigoElemento", "codigoElemento"],
  null
);

const codigoOcurrenciaDe = (respuesta) => obtenerPrimero(
  respuesta,
  ["CodigoOcurrencia", "codigoOcurrencia"],
  CODIGO_OCURRENCIA_UNICA
) || CODIGO_OCURRENCIA_UNICA;

const estadoDe = (respuesta) => obtenerPrimero(
  respuesta,
  ["EstadoRespuesta", "estadoRespuesta", "Estado", "estado"],
  ESTADOS_RESPUESTA.SIN_RESPONDER
);

export const contextosNavegablesDe = (definicion) => (definicion?.Bloques || []).flatMap((bloque) =>
  (bloque.Secciones || []).flatMap((seccion) =>
    (seccion.Elementos || []).map((elemento) => ({ bloque, seccion, elemento }))
  )
);

export const obtenerPreguntasPendientes = (
  definicion,
  respuestas = [],
  seccionesOmitidas = []
) => contextosNavegablesDe(definicion).flatMap((contexto) => {
  const { seccion, elemento } = contexto;
  if (seccionesOmitidas.includes(seccion.Codigo)) return [];

  const asociadas = respuestas.filter((respuesta) => codigoElementoDe(respuesta) === elemento.Codigo);
  if (!elemento.EsRepetible && elemento.TipoRespuesta !== "REPEATABLE_FORM") {
    const respuesta = asociadas.find((item) => codigoOcurrenciaDe(item) === CODIGO_OCURRENCIA_UNICA);
    const estado = estadoDe(respuesta);
    return !respuesta || [ESTADOS_RESPUESTA.SIN_RESPONDER, ESTADOS_RESPUESTA.PARA_DESPUES].includes(estado)
      ? [{ ...contexto, codigoOcurrencia: CODIGO_OCURRENCIA_UNICA, estado }]
      : [];
  }

  const marcador = asociadas.find((respuesta) =>
    codigoOcurrenciaDe(respuesta) === CODIGO_OCURRENCIA_OMISION_PREGUNTA
  );
  if (estadoDe(marcador) === ESTADOS_RESPUESTA.OMITIDA) return [];

  const operativas = asociadas.filter((respuesta) =>
    codigoOcurrenciaDe(respuesta) !== CODIGO_OCURRENCIA_OMISION_PREGUNTA
  );
  const pendiente = operativas.find((respuesta) =>
    [ESTADOS_RESPUESTA.SIN_RESPONDER, ESTADOS_RESPUESTA.PARA_DESPUES].includes(estadoDe(respuesta))
  );
  if (pendiente) {
    return [{
      ...contexto,
      codigoOcurrencia: codigoOcurrenciaDe(pendiente),
      estado: estadoDe(pendiente),
    }];
  }
  return operativas.length === 0
    ? [{ ...contexto, codigoOcurrencia: CODIGO_OCURRENCIA_UNICA, estado: ESTADOS_RESPUESTA.SIN_RESPONDER }]
    : [];
});

export const puedeMostrarAccesoFinal = (
  definicion,
  respuestas = [],
  seccionesOmitidas = []
) => Boolean(definicion) && obtenerPreguntasPendientes(definicion, respuestas, seccionesOmitidas)
  .every(({ estado }) => estado === ESTADOS_RESPUESTA.PARA_DESPUES);

export const obtenerDestinoBloque = (
  bloque,
  definicion,
  respuestas = [],
  seccionesOmitidas = []
) => {
  const pendiente = obtenerPreguntasPendientes(definicion, respuestas, seccionesOmitidas)
    .find((contexto) => contexto.bloque.Codigo === bloque?.Codigo);
  if (pendiente) return pendiente;
  const seccion = bloque?.Secciones?.[0];
  const elemento = seccion?.Elementos?.[0];
  return seccion && elemento
    ? { bloque, seccion, elemento, codigoOcurrencia: CODIGO_OCURRENCIA_UNICA }
    : null;
};

const normalizarCodigo = (codigo) => String(codigo || "")
  .toUpperCase()
  .replace(/[^A-Z0-9]/g, "");

export const resolverElementoDeValidacion = (validacion, definicion) => {
  const codigoExplicito = obtenerPrimero(
    validacion,
    ["CodigoElemento", "codigoElemento"],
    null
  );
  const codigoValidacion = obtenerPrimero(validacion, ["Codigo", "codigo"], "");
  const candidatos = contextosNavegablesDe(definicion);
  if (codigoExplicito) {
    return candidatos.find(({ elemento }) => elemento.Codigo === codigoExplicito) || null;
  }
  const prefijo = String(codigoValidacion).split(":")[0];
  const normalizado = normalizarCodigo(prefijo);
  if (!normalizado) return null;
  return candidatos.find(({ elemento }) =>
    normalizado.startsWith(normalizarCodigo(elemento.Codigo))
  ) || null;
};
